export default "__VITE_ASSET__DhgBVe2q__"